export default "__VITE_ASSET__DxvPrnnE__"